export default "__VITE_ASSET__B0Fmk4oW__"